(function () {
  var MAP = [
    {
      barId: "a2f970e0-ebf2-4536-b843-9deb552cce39",
      match: /(^|\b)(1\s*Brush\s*\+\s*2\s*Cleansing\s*Mist\s*Bottles|The\s*Starter\s*Set)\b/i,
      img: "https://cdn.shopify.com/s/files/1/0609/5821/2195/files/Frame_2085667924_2.png?v=1769172515",
      title: "The Starter Set",
      lead: "Perfect for first-timers.",
      bullets: ["✓ 1 month supply"],
      badge: null,
      saveText: null,
      tier: "starter"
    },
    {
      barId: "eb8cefbe-0c30-455a-899d-33b84eaed8aa",
      match: /(^|\b)(1\s*Brush\s*\+\s*4\s*Cleansing\s*Mist\s*Bottles|The\s*Deep\s*Clean\s*Kit)\b/i,
      img: "https://cdn.shopify.com/s/files/1/0609/5821/2195/files/Frame_2085667924_1.png?v=1769172515",
      title: "The Deep Clean Kit",
      lead: "6-Month Supply",
      bullets: [
        "✓ 3 bottles",
        "✓ Nail Grinder <span class=\"cw-free-inline\">$39.95</span> <span class=\"cw-free-inline cw-free\">Free</span>"
      ],
      badge: { text: "Most Popular", type: "orange" },
      saveText: null,
      tier: "deep"
    },
    {
      barId: "b743a685-28a5-4d09-a48e-92dbb624eb82",
      match: /(^|\b)(1\s*Brush\s*\+\s*6\s*Cleansing\s*Mist\s*Bottles|The\s*Ultimate\s*Spa\s*System)\b/i,
      img: "https://cdn.shopify.com/s/files/1/0609/5821/2195/files/Frame_2085667924.png?v=1769172515",
      title: "The Ultimate Spa System",
      lead: "Total Wellness - 1 year supply",
      bullets: [
        "✓ 6 Bottles",
        "✓ Nail Grinder",
        "✓ Balm",
        "✓ Guided PDF for 29$ <span class=\"cw-free-inline cw-free\">Free</span>"
      ],
      badge: { text: "Best Value + Free Shipping", type: "blue" },
      saveText: "Save $66",
      tier: "ultimate"
    }
  ];

  var PDF_VARIANT_ID = 0;
  var SUBSCRIBE_SAVE_TEXT = "Save $90";

  var STYLE_ID = "cw-kaching-refactor-v1";
  var IMG_CLASS = "cw-kaching-bundle-img";
  var BADGE_CLASS = "cw-kaching-bundle-badge";
  var SAVE_CLASS = "cw-kaching-bundle-save";
  var TEXT_CLASS = "cw-kaching-bundle-text";
  var LEAD_CLASS = "cw-kaching-bundle-lead";
  var LIST_CLASS = "cw-kaching-bundle-list";

  function injectCSS() {
    if (document.getElementById(STYLE_ID)) return;

    var css = `
      .kaching-bundles__bar[data-deal-bar-id] .kaching-bundles__bar-container,
      .kaching-bundles__bar[data-deal-bar-id] .kaching-bundles__bar-container *{
        font-family: Poppins, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif !important;
      }

      .kaching-bundles__block > .kaching-bundles__bars{
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
      }

      .kaching-bundles__block > .kaching-bundles__bars .kaching-bundles__bar[data-deal-bar-id]{
        margin: 6px 0 !important;
      }

      .kaching-bundles__bar[data-deal-bar-id] .kaching-bundles__bar-container{
        position: relative !important;
        border-radius: 8px !important;
        overflow: visible !important;
        background: #fff !important;
        border: 1px solid rgba(15,23,42,.20) !important;
        display: block !important;
        cursor: pointer !important;
        pointer-events: auto !important;
      }

      .kaching-bundles__bar[data-deal-bar-id] .kaching-bundles__bar-radio{
        display: none !important;
      }

      .kaching-bundles__bar[data-deal-bar-id] input[type="radio"]{
        position: absolute !important;
        opacity: 0 !important;
        width: 1px !important;
        height: 1px !important;
        margin: 0 !important;
        padding: 0 !important;
        left: 0 !important;
        top: 0 !important;
        pointer-events: none !important;
      }

      .kaching-bundles__bar[data-deal-bar-id] .kaching-bundles__bar-wrapper,
      .kaching-bundles__bar[data-deal-bar-id] .kaching-bundles__bar-main{
        pointer-events: auto !important;
      }

      .kaching-bundles__bar[data-deal-bar-id] .kaching-bundles__bar-content{
        width: 100% !important;
        display: grid !important;
        grid-template-columns: 1fr auto !important;
        column-gap: 16px !important;
        align-items: start !important;
        padding: 16px 18px !important;
      }

      .kaching-bundles__bar[data-deal-bar-id] .kaching-bundles__bar-content-left{
        display: grid !important;
        grid-template-columns: 86px 1fr !important;
        column-gap: 18px !important;
        align-items: start !important;
        min-width: 0 !important;
      }

      .${IMG_CLASS}{
        width: 86px !important;
        height: 86px !important;
        object-fit: contain !important;
        display: block !important;
      }

      .kaching-bundles__bar[data-deal-bar-id] .kaching-bundles__bar-first-line{
        display: flex !important;
        align-items: baseline !important;
        justify-content: space-between !important;
        gap: 14px !important;
        min-width: 0 !important;
      }

      .kaching-bundles__bar[data-deal-bar-id] .kaching-bundles__bar-title{
        font-size: 20px;
        line-height: 1.05 !important;
        font-weight: 600 !important;
        margin: 0 !important;
        color: #000 !important;
        white-space: normal !important;
      }

      .${TEXT_CLASS}{
        min-width: 0 !important;
      }

      .${LEAD_CLASS}{
        margin-top: 6px !important;
        font-size: 14px;
        line-height: 1.2 !important;
        font-weight: 400 !important;
        color: #000 !important;
      }

      .${LIST_CLASS}{
        margin-top: 6px !important;
        display: grid !important;
        row-gap: 3px !important;
        font-size: 12px;
        line-height: 1.25 !important;
        font-weight: 400 !important;
        color: #000 !important;
      }

      .cw-free-inline{
        font-size: 12px !important;
        opacity: .85 !important;
        margin-left: 6px !important;
        text-decoration: line-through !important;
      }

      .cw-free-inline.cw-free{
        text-decoration: none !important;
        opacity: 1 !important;
        color: #16A34A !important;
        font-weight: 800 !important;
      }

      .kaching-bundles__bar[data-deal-bar-id] .kaching-bundles__bar-pricing{
        display: flex !important;
        flex-direction: row;
        align-items: flex-end !important;
        gap: 6px !important;
        white-space: nowrap !important;
        text-align: right !important;
        padding-top: 2px !important;
      }

      .kaching-bundles__bar[data-deal-bar-id] .kaching-bundles__bar-full-price{
        text-decoration: line-through !important;
        font-size: 14px !important;
        font-weight: 400 !important;
        line-height: 1 !important;
        color: #000 !important;
        opacity: .65 !important;
      }

      .kaching-bundles__bar[data-deal-bar-id] .kaching-bundles__bar-price{
        font-size: 18px !important;
        font-weight: 700 !important;
        line-height: 1 !important;
        color: #000 !important;
      }

      .${SAVE_CLASS}{
        font-size: 12px !important;
        font-weight: 800 !important;
        color: #16A34A !important;
        line-height: 1 !important;
      }

      .kaching-bundles__bar[data-deal-bar-id] .kaching-bundles__bar-most-popular{
        display: none !important;
      }

      .${BADGE_CLASS}{
        position: absolute !important;
        top: 1px !important;
        right: 1px !important;
        z-index: 5 !important;
        font-size: 12px !important;
        line-height: 1 !important;
        padding: 4px 8px !important;
        border-radius: 5px !important;
        font-weight: 700 !important;
        color: #fff !important;
        white-space: nowrap !important;
        pointer-events: none !important;
      }

      .${BADGE_CLASS}.orange{ background: #E38A0A !important; }
      .${BADGE_CLASS}.blue{ background: #1E3A8A !important; }

      .kaching-bundles__bar[data-deal-bar-id].kaching-bundles__bar--selected .kaching-bundles__bar-container{
        border: 2px solid #000 !important;
        box-shadow: none !important;
      }

      .kaching-bundles__bar[data-deal-bar-id][data-cw-tier="ultimate"]:not(.kaching-bundles__bar--selected) .kaching-bundles__bar-container{
        border: 1px solid rgba(15,23,42,.20) !important;
        box-shadow: none !important;
      }

      .kaching-bundles__bar[data-deal-bar-id][data-cw-tier="ultimate"].kaching-bundles__bar--selected .kaching-bundles__bar-container{
        border: 2px solid rgba(30, 58, 138, .95) !important;
        box-shadow: 0 0 0 1px rgba(30, 58, 138, .18) inset !important;
      }
    `;

    var style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = css;
    document.head.appendChild(style);
  }

  function formatMoneyDisplay(raw) {
    var t = (raw || "").trim();
    if (!t) return t;
    if (/^\$\d+$/.test(t)) return t + ".00";
    return t;
  }

  function getTitleText(bar) {
    var t = bar.querySelector(".kaching-bundles__bar-title");
    return (t && t.textContent || "").trim();
  }

  function getDealBarId(bar) {
    return (bar.getAttribute("data-deal-bar-id") || "").trim();
  }

  function isDealBar(bar) {
    if (!bar || bar.nodeType !== 1) return false;
    var id = getDealBarId(bar);
    if (!id) return false;
    var input = bar.querySelector('input[type="radio"][name^="kaching-bundles-deal-"]');
    return !!input;
  }

  function findConfig(bar, title) {
    var id = getDealBarId(bar);
    if (id) {
      for (var i = 0; i < MAP.length; i++) {
        if (MAP[i].barId && MAP[i].barId === id) return MAP[i];
      }
    }
    for (var j = 0; j < MAP.length; j++) {
      if (MAP[j].match && MAP[j].match.test(title)) return MAP[j];
    }
    return null;
  }

  function ensureImage(bar, cfg) {
    var left = bar.querySelector(".kaching-bundles__bar-content-left");
    if (!left) return;
    if (left.querySelector("." + IMG_CLASS)) return;

    var img = document.createElement("img");
    img.className = IMG_CLASS;
    img.alt = "";
    img.loading = "lazy";
    img.src = cfg.img;

    left.insertBefore(img, left.firstChild);
  }

  function ensureTextBlock(bar, cfg) {
    var left = bar.querySelector(".kaching-bundles__bar-content-left");
    if (!left) return;

    var firstLine = bar.querySelector(".kaching-bundles__bar-first-line");
    var titleEl = bar.querySelector(".kaching-bundles__bar-title");
    var subtitleWrap = bar.querySelector(".kaching-bundles__bar-second-line");

    if (!titleEl) return;

    titleEl.textContent = cfg.title;

    var text = left.querySelector("." + TEXT_CLASS);
    if (!text) {
      text = document.createElement("div");
      text.className = TEXT_CLASS;

      if (firstLine && firstLine.parentNode) {
        firstLine.parentNode.insertBefore(text, firstLine);
        text.appendChild(firstLine);
      } else {
        left.appendChild(text);
      }

      if (subtitleWrap) subtitleWrap.remove();
    } else {
      if (subtitleWrap) subtitleWrap.remove();
      if (firstLine && !text.contains(firstLine)) {
        text.insertBefore(firstLine, text.firstChild);
      }
    }

    var lead = text.querySelector("." + LEAD_CLASS);
    if (!lead) {
      lead = document.createElement("div");
      lead.className = LEAD_CLASS;
      text.appendChild(lead);
    }
    lead.textContent = cfg.lead;

    var list = text.querySelector("." + LIST_CLASS);
    if (!list) {
      list = document.createElement("div");
      list.className = LIST_CLASS;
      text.appendChild(list);
    }
    list.innerHTML = cfg.bullets.map(function (b) { return "<div>" + b + "</div>"; }).join("");
  }

  function ensureBadge(bar, cfg) {
    var container = bar.querySelector(".kaching-bundles__bar-container");
    if (!container) return;

    var existing = container.querySelector("." + BADGE_CLASS);
    if (existing) existing.remove();

    if (!cfg.badge) return;

    var badge = document.createElement("div");
    badge.className = BADGE_CLASS + " " + cfg.badge.type;
    badge.textContent = cfg.badge.text;
    container.appendChild(badge);
  }

  function ensureSave(bar, cfg) {
    var pricing = bar.querySelector(".kaching-bundles__bar-pricing");
    if (!pricing) return;

    var existing = pricing.querySelector("." + SAVE_CLASS);
    if (existing) existing.remove();

    if (!cfg.saveText) return;

    var save = document.createElement("span");
    save.className = SAVE_CLASS;
    save.textContent = cfg.saveText;
    pricing.appendChild(save);
  }

  function normalizePrices(bar) {
    var pricing = bar.querySelector(".kaching-bundles__bar-pricing");
    if (!pricing) return;

    var full = pricing.querySelector(".kaching-bundles__bar-full-price");
    var cur = pricing.querySelector(".kaching-bundles__bar-price");

    if (full) full.textContent = formatMoneyDisplay(full.textContent);
    if (cur) cur.textContent = formatMoneyDisplay(cur.textContent);

    if (full && cur) {
      if (pricing.firstChild !== full) pricing.insertBefore(full, cur);
    }
  }

  function markTier(bar, cfg) {
    bar.setAttribute("data-cw-tier", cfg.tier);
  }

  function bindClickProxy(bar) {
    if (bar.__cwClickBound) return;
    bar.__cwClickBound = true;

    var input = bar.querySelector('input[type="radio"][name^="kaching-bundles-deal-"]');
    if (!input) return;

    var container = bar.querySelector(".kaching-bundles__bar-container") || bar;

    function shouldIgnoreClick(target) {
      if (!target) return false;
      return !!target.closest('a, button, select, option, input, textarea, label, [role="button"], [contenteditable="true"]');
    }

    container.addEventListener("click", function (e) {
      if (shouldIgnoreClick(e.target)) return;
      if (input.disabled) return;
      if (!input.checked) input.click();
    }, true);

    container.addEventListener("keydown", function (e) {
      if (e.key !== "Enter" && e.key !== " ") return;
      if (input.disabled) return;
      if (shouldIgnoreClick(e.target)) return;
      e.preventDefault();
      if (!input.checked) input.click();
    });

    if (!container.hasAttribute("tabindex")) container.setAttribute("tabindex", "0");
    container.setAttribute("role", "radio");
    container.setAttribute("aria-checked", input.checked ? "true" : "false");

    input.addEventListener("change", function () {
      container.setAttribute("aria-checked", input.checked ? "true" : "false");
    });
  }

  function patchOne(bar) {
    if (!isDealBar(bar)) return;

    var title = getTitleText(bar);
    var cfg = findConfig(bar, title);
    if (!cfg) return;

    injectCSS();
    ensureImage(bar, cfg);
    ensureTextBlock(bar, cfg);
    ensureBadge(bar, cfg);
    ensureSave(bar, cfg);
    normalizePrices(bar);
    markTier(bar, cfg);
    bindClickProxy(bar);
  }

  function patchAll(root) {
    var scope = root || document;
    var bars = scope.querySelectorAll('.kaching-bundles__bar[data-deal-bar-id]');
    for (var i = 0; i < bars.length; i++) patchOne(bars[i]);
  }

  function updateFreeShippingText(root) {
    var scope = root || document;
    var items = scope.querySelectorAll(".icon-with-text__item span");
    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      if (!el.textContent) continue;
      if (/Free Shipping Over\s*\$55/i.test(el.textContent)) {
        el.textContent = el.textContent.replace(/\$55/i, "$75");
      }
    }
  }

  function getSelectedSubscriptionMode() {
    var subRoot = document.querySelector(".kaching-bundles__subscriptions");
    if (!subRoot) return null;

    var selected = subRoot.querySelector(".kaching-bundles__bar.kaching-bundles__bar--selected");
    if (!selected) return null;

    var title = selected.querySelector(".kaching-bundles__subscriptions__title");
    var t = (title && title.textContent || "").trim().toLowerCase();

    if (t.indexOf("subscribe") !== -1) return "subscribe";
    if (t.indexOf("one-time") !== -1 || t.indexOf("one time") !== -1) return "onetime";
    return null;
  }

  function updateUltimateSaveBySubscription() {
    var mode = getSelectedSubscriptionMode();
    if (!mode) return;

    var saveEl = document.querySelector('.kaching-bundles__bar[data-deal-bar-id][data-cw-tier="ultimate"] .cw-kaching-bundle-save');
    if (!saveEl) return;

    if (!saveEl.getAttribute("data-cw-save-onetime")) {
      saveEl.setAttribute("data-cw-save-onetime", (saveEl.textContent || "").trim());
    }

    var onetimeText = saveEl.getAttribute("data-cw-save-onetime") || (saveEl.textContent || "").trim();

    if (mode === "subscribe") saveEl.textContent = SUBSCRIBE_SAVE_TEXT;
    if (mode === "onetime") saveEl.textContent = onetimeText;
  }

  function getSelectedTier() {
    var selected = document.querySelector('.kaching-bundles__bar.kaching-bundles__bar--selected[data-deal-bar-id]');
    if (!selected) return null;
    return selected.getAttribute("data-cw-tier") || null;
  }

  function getQuantityFromForm(form) {
    var qtyEl = form.querySelector('input[name="quantity"]');
    var qty = qtyEl ? parseInt(qtyEl.value, 10) : 1;
    return isFinite(qty) && qty > 0 ? qty : 1;
  }

  function getVariantIdFromForm(form) {
    var idEl = form.querySelector('input[name="id"]');
    if (!idEl) return null;
    var id = parseInt(idEl.value, 10);
    return isFinite(id) && id > 0 ? id : null;
  }

  function ajaxAddItems(items) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error("cart/add failed");
      return r.json();
    });
  }

  function shouldHandle(form) {
    if (!form || form.nodeType !== 1) return false;
    var action = (form.getAttribute("action") || "").toLowerCase();
    if (!action || action.indexOf("/cart/add") === -1) return false;
    if (!form.querySelector('input[name="id"]')) return false;
    return true;
  }

  function bindPdfAddOnce() {
    if (document.__cwPdfBind) return;
    document.__cwPdfBind = true;

    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (!shouldHandle(form)) return;

      var tier = getSelectedTier();
      if (tier !== "ultimate") return;

      if (!PDF_VARIANT_ID || PDF_VARIANT_ID <= 0) return;

      var mainId = getVariantIdFromForm(form);
      if (!mainId) return;

      e.preventDefault();

      var qty = getQuantityFromForm(form);

      ajaxAddItems([
        { id: mainId, quantity: qty },
        { id: PDF_VARIANT_ID, quantity: 1 }
      ]).then(function () {
        document.dispatchEvent(new CustomEvent("cw:cart:updated"));
      }).catch(function () {
        try { form.submit(); } catch (err) {}
      });
    }, true);
  }

  function boot() {
    injectCSS();
    patchAll(document);
    updateFreeShippingText(document);
    updateUltimateSaveBySubscription();
    bindPdfAddOnce();

    document.addEventListener("click", function (e) {
      var t = e.target;
      if (!t) return;
      if (t.closest && t.closest(".kaching-bundles__subscriptions")) {
        setTimeout(updateUltimateSaveBySubscription, 0);
      }
    }, true);

    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (!m.addedNodes || !m.addedNodes.length) continue;

        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (node.nodeType !== 1) continue;

          if (node.matches && node.matches('.kaching-bundles__bar[data-deal-bar-id]')) patchOne(node);
          patchAll(node);
          updateFreeShippingText(node);

          if (node.matches && (node.matches(".kaching-bundles__subscriptions") || node.closest && node.closest(".kaching-bundles__subscriptions"))) {
            setTimeout(updateUltimateSaveBySubscription, 0);
          }
        }
      }
    });

    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();

(function () {
  var SAVE_CLASS = "cw-kaching-bundle-save";
  var SAVE_LABEL_PREFIX = "Save $";

  function parseMoneyToNumber(text) {
    var t = (text || "").replace(/,/g, "").match(/-?\d+(\.\d+)?/);
    if (!t) return 0;
    var n = parseFloat(t[0]);
    return isFinite(n) ? n : 0;
  }

  function getSaveAmount(bar) {
    var fullEl = bar.querySelector(".kaching-bundles__bar-full-price");
    var priceEl = bar.querySelector(".kaching-bundles__bar-price");
    if (!fullEl || !priceEl) return null;

    var full = parseMoneyToNumber(fullEl.textContent);
    var cur = parseMoneyToNumber(priceEl.textContent);

    if (!full || !cur) return null;

    var diff = full - cur;
    if (!isFinite(diff)) return null;

    diff = Math.round(diff);
    return diff;
  }

  function ensureSaveEl(bar) {
    var pricing = bar.querySelector(".kaching-bundles__bar-pricing");
    if (!pricing) return null;

    var el = pricing.querySelector("." + SAVE_CLASS);
    if (!el) {
      el = document.createElement("span");
      el.className = SAVE_CLASS;
      pricing.appendChild(el);
    }
    return el;
  }

  function updateBar(bar) {
    if (!bar || !bar.matches || !bar.matches('.kaching-bundles__bar[data-deal-bar-id]')) return;

    var saveEl = ensureSaveEl(bar);
    if (!saveEl) return;

    var diff = getSaveAmount(bar);

    if (diff === null || diff <= 0) {
      saveEl.textContent = "";
      saveEl.style.display = "none";
      return;
    }

    saveEl.textContent = SAVE_LABEL_PREFIX + diff;

    if (bar.classList.contains("kaching-bundles__bar--selected")) {
      saveEl.style.display = "inline";
    } else {
      saveEl.style.display = "none";
    }
  }

  function updateAll(root) {
    var scope = root || document;
    var bars = scope.querySelectorAll('.kaching-bundles__bar[data-deal-bar-id]');
    for (var i = 0; i < bars.length; i++) updateBar(bars[i]);
  }

  function boot() {
    updateAll(document);

    document.addEventListener("click", function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      if (t.closest('.kaching-bundles__bar[data-deal-bar-id]')) {
        setTimeout(function () { updateAll(document); }, 0);
        return;
      }

      if (t.closest(".kaching-bundles__subscriptions")) {
        setTimeout(function () { updateAll(document); }, 0);
        return;
      }
    }, true);

    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];

        if (m.type === "attributes") {
          var target = m.target;
          if (target && target.nodeType === 1) {
            if (target.matches && target.matches('.kaching-bundles__bar[data-deal-bar-id]')) {
              updateBar(target);
            } else {
              updateAll(target);
            }
          }
          continue;
        }

        if (!m.addedNodes || !m.addedNodes.length) continue;

        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (!node || node.nodeType !== 1) continue;

          if (node.matches && node.matches('.kaching-bundles__bar[data-deal-bar-id]')) updateBar(node);
          updateAll(node);
        }
      }
    });

    obs.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class"]
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();



function waitForElement(selector, timer = 30000, frequency = 100) {
  return new Promise((resolve, reject) => {
    const el = document.querySelector(selector);
    if (el) return resolve(el);
    if (timer <= 0) return reject(`waitForElement | Couldn't find element with selector: ${selector}`);
    setTimeout(() => {
      waitForElement(selector, timer - frequency, frequency).then(resolve).catch(reject);
    }, frequency);
  });
}

(function () {
  const THRESHOLD = 75;
  let lastSubtotal = null;
  let originalTextHTML = null;

  function getSubtotal() {
    const el = document.querySelector(
      "p.cart-drawer__totals__row.cart-drawer__totals__row--spaced.text-color-text .cart-drawer__totals__row__money"
    );
    if (!el) return null;
    const n = parseFloat(el.textContent.replace(/[^0-9.]/g, ""));
    return Number.isFinite(n) ? n : null;
  }

  function captureOriginalText() {
    const textEl = document.querySelector(".cart-progress__text");
    if (!textEl) return null;

    const html = textEl.innerHTML;
    const hasSpanMoney = !!textEl.querySelector("span");
    const looksLikeCongrats = /congrats!/i.test(textEl.textContent || "");

    if (hasSpanMoney && !looksLikeCongrats) {
      originalTextHTML = html;
    }

    return textEl;
  }

  function setAway(textEl, amount) {
    if (!textEl) return;
    if (originalTextHTML) {
      if (textEl.innerHTML !== originalTextHTML) textEl.innerHTML = originalTextHTML;
      const span = textEl.querySelector("span");
      if (span) span.textContent = `$${amount.toFixed(2)}`;
    } else {
      textEl.textContent = `You're only $${amount.toFixed(2)} away from FREE SHIPPING`;
    }
  }

  function setCongrats(textEl) {
    if (!textEl) return;
    textEl.textContent = "Congrats! You get FREE shipping!";
  }

  function update() {
    const subtotal = getSubtotal();
    if (subtotal === null || subtotal === lastSubtotal) return;
    lastSubtotal = subtotal;

    const fill = document.querySelector(".cart-progress__bar__progress");
    const textEl = document.querySelector(".cart-progress__text");
    if (!fill || !textEl) return;

    const unlocked = subtotal >= THRESHOLD;

    if (unlocked) {
      fill.style.width = "100%";
      setCongrats(textEl);
      return;
    }

    const percent = Math.min((subtotal / THRESHOLD) * 100, 100);
    fill.style.width = percent + "%";
    setAway(textEl, THRESHOLD - subtotal);
  }

  function boot() {
    captureOriginalText();

    const obs = new MutationObserver(() => {
      captureOriginalText();
      update();
    });

    obs.observe(document.documentElement, { childList: true, subtree: true });

    update();
    setInterval(update, 250);
  }

  waitForElement(".cart-progress__bar__progress").then(boot).catch(console.error);
})();
